<script lang="ts">
  import Comparative from "./comparative/Comparative.svelte";
  import Current from "./current/Current.svelte";
  import Norm from "./norm/Norm.svelte";
  import type { Price } from "../../../types/CinemaProductsDto.types.ts";
  import Deal from "./deal/Deal.svelte";

  interface Props {
    price: Price;
  }

  const { price }: Props = $props();
</script>

<div>
  {#if price.comparative}
    <Comparative comparative={price.comparative} />
  {/if}

  <Current current={price.current} isUvp={price.comparative?.isUvp ?? false} />

  {#if price.deal}
    <Deal deal={price.deal} />
  {/if}

  {#if price.norm}
    <Norm norm={price.norm} />
  {/if}
</div>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  div {
    font: tokens.$oc-semantic-font-copy-100;
    margin-top: tokens.$oc-semantic-spacing-50;
    display: flex;
    flex-direction: column;
  }
</style>
